import React, { useState } from "react";
import LoadingSpinner from "../ui/LoadingSpinner";

const ButtonLoadingWrap = ({ button }) => {
    const [loading, setLoading] = useState(false);

    return (
        <div className="button-loading-wrap">
            {!loading && React.cloneElement(button, {
                onClick: async (e) => {
                    setLoading(true);
                    await button.props.onClick(e);
                    setLoading(false);
                }
            })}

            {loading && <LoadingSpinner />}
        </div>
    );
};

export default ButtonLoadingWrap;